import { render, staticRenderFns } from "./PropertyUpdateTable.vue?vue&type=template&id=0cf2f196"
import script from "./PropertyUpdateTable.vue?vue&type=script&lang=ts"
export * from "./PropertyUpdateTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports